import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipButtonComponent } from './payment-sip-button.component';
import { MatButtonModule } from '@angular/material/button';
import { InViewportModule } from 'ng-in-viewport';

@NgModule({
  declarations: [PaymentSipButtonComponent],
  exports: [PaymentSipButtonComponent],
  imports: [
    CommonModule,
    InViewportModule,
    MatButtonModule
  ]
})
export class PaymentSipButtonModule { }
